import { HttpErrorResponse } from '@angular/common/http';

function normalizeErrorKey(msg: string): string {
  if (!msg) return msg;
  const lower = msg.toLowerCase();
  if (
    lower.includes('email') &&
    (lower.includes('use') || lower.includes('taken') || lower.includes('exist'))
  ) {
    return 'errors.emailInUse';
  }
  return msg;
}

export function getErrorMessage(error: HttpErrorResponse | string): string {
  if (typeof error === 'string') {
    return normalizeErrorKey(error);
  }

  if (error instanceof HttpErrorResponse) {
    if (error.status === 403) {
      return 'errors.noPermission';
    }
    if (error.status === 401) {
      return 'errors.loginAgain';
    }
  }

  if (error?.error) {
    const errorObj = error.error;

    if (typeof errorObj === 'string') {
      return normalizeErrorKey(errorObj);
    }

    if (typeof errorObj === 'object' && errorObj !== null) {
      // 1. Check for specific validation errors (ASP.NET Core ProblemDetails errors object/array)
      if (errorObj.errors) {
        let rawMsg = '';
        if (Array.isArray(errorObj.errors)) {
          rawMsg = errorObj.errors.filter(Boolean).join('. ');
        } else if (typeof errorObj.errors === 'object') {
          const messages: string[] = [];
          for (const key of Object.keys(errorObj.errors)) {
            const fieldErrors = errorObj.errors[key];
            if (Array.isArray(fieldErrors)) {
              messages.push(...fieldErrors.filter(Boolean));
            } else if (typeof fieldErrors === 'string' && fieldErrors) {
              messages.push(fieldErrors);
            }
          }
          if (messages.length > 0) {
            rawMsg = messages.join('. ');
          }
        } else if (typeof errorObj.errors === 'string') {
          rawMsg = errorObj.errors;
        }

        if (rawMsg) {
          return normalizeErrorKey(rawMsg);
        }
      }

      // 2. Check for description / detail / message
      if (errorObj.description && typeof errorObj.description === 'string') {
        return normalizeErrorKey(errorObj.description);
      }

      if (errorObj.detail && typeof errorObj.detail === 'string') {
        return normalizeErrorKey(errorObj.detail);
      }

      if (errorObj.message && typeof errorObj.message === 'string') {
        return normalizeErrorKey(errorObj.message);
      }

      // 3. Fallback to title only if it's not the generic validation summary
      if (
        errorObj.title &&
        typeof errorObj.title === 'string' &&
        errorObj.title !== 'One or more validation errors occurred.'
      ) {
        return normalizeErrorKey(errorObj.title);
      }
    }
  }

  if (error?.status) {
    return `Request failed with ${error.status} ${error.statusText}`;
  }

  if (error instanceof Error) {
    return normalizeErrorKey(error.message);
  }

  return 'errors.somethingWentWrong';
}
